/* Built In Imports */
import React, { useState } from 'react';
/* External Imports */
import { Box, Collapse, Flex, Image } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
/* Internal Imports */
/* Components */
import ShowScienceSt from '@moms/styleData/ShowScienceSt';
import LazyLoadImageComponent from '@moms/Ui/LazyLoadImageComponent';
import SciImage from '@moms/Ui/SciImage';
import StructuredTextParser from '@moms/Utility/StructuredTextParser';
/* Styles */
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */

const MainUi = ({ region, lang, sectionContent }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const expertSaying = sectionContent.find(
    el => el.fieldId === 'expert-saying'
  );
  const stWalk = sectionContent.find(el => el.fieldId === 'st-walk');
  const stSteps = sectionContent.find(el => el.fieldId === 'st-steps');
  const stStayFit = sectionContent.find(el => el.fieldId === 'st-stay-fit');
  const step1Img = sectionContent.find(el => el.fieldId === 'step1-img');
  const stAdding = sectionContent.find(el => el.fieldId === 'st-adding');
  const stMeditate = sectionContent.find(el => el.fieldId === 'st-meditate');
  const stMinutes = sectionContent.find(el => el.fieldId === 'st-minutes');
  const stShape = sectionContent.find(el => el.fieldId === 'st-shape');
  const step2Img = sectionContent.find(el => el.fieldId === 'step2-img');
  const stScienceText = sectionContent.find(
    el => el.fieldId === 'st-science-text'
  );
  const stScienceImgText = sectionContent.find(
    el => el.fieldId === 'st-science-img-text'
  );
  const scienceImg = sectionContent.find(el => el.fieldId === 'science-img');
  return (
    <Box maxW={1330} w="100%" mx="auto">
      <Flex flexDir={{ base: 'column', md: 'row' }}>
        <Box flex={1} maxW={500} pt="120px">
          <Box
            maxW={{ base: 300, md: 250 }}
            mx={{ base: '0', md: 'auto' }}
            px={{ base: '1rem', md: '0' }}
          >
            <StructuredTextParser
              mt="0"
              str={render(expertSaying.body)}
              sx={{
                p: {
                  color: '#fff',
                },
                em: {
                  color: '#F21D2E',
                },
              }}
              {...ShowScienceSt[lang].expertText}
            />
            <StructuredTextParser
              mt="15px"
              str={render(stWalk.body)}
              {...ShowScienceSt[lang].walksText}
            />
            <StructuredTextParser
              mt="0"
              str={render(stSteps.body)}
              {...ShowScienceSt[lang].stepsText}
            />
            <StructuredTextParser
              mt="0"
              str={render(stStayFit.body)}
              {...ShowScienceSt[lang].fitText}
            />
          </Box>
          <Image
            mt={{ base: '0', md: '126px' }}
            src={step1Img.image.url}
            verticalAlign="middle"
          />
        </Box>
        <Box
          flex={1}
          bgImage={{ base: 'none', md: step2Img.image.url }}
          bgRepeat="no-repeat"
          bgSize="cover"
          bgPos="center"
          pt={{ base: '30px', md: '120px' }}
          pl={{ base: '30px', md: '100px' }}
          pr={{ base: '30px', md: '0' }}
        >
          <Box>
            <StructuredTextParser
              str={render(stAdding.body)}
              mt={{ base: '1rem', md: '0' }}
              sx={{
                p: {
                  color: 'rgba(255, 255, 255, 0.80)',
                  fontFamily: 'Geist',
                },
                em: {
                  color: '#F21D2E',
                  fontFamily: 'Trirong',
                },
              }}
              {...ShowScienceSt[lang].addingText}
            />
            <StructuredTextParser
              str={render(stMeditate.body)}
              mt="10px"
              {...ShowScienceSt[lang].walksText}
            />
            <StructuredTextParser
              str={render(stMinutes.body)}
              mt="0"
              {...ShowScienceSt[lang].stepsText}
            />
            <StructuredTextParser
              str={render(stShape.body)}
              mt="0"
              mb={{ base: '0', md: '64px' }}
              {...ShowScienceSt[lang].fitText}
            />
            <Collapse animateOpacity in={isVisible}>
              <Flex
                alignItems="flex-start"
                flexDir={{ base: 'column', xl: 'row' }}
                mt={{ base: '2.5rem', md: '0', xl: '3.5rem' }}
                pr="1rem"
                mb={{ md: '0', base: '3rem' }}
                // gap="1rem"
              >
                <Box color="#fff">
                  <StructuredTextParser
                    str={render(stScienceText.body)}
                    mt="0"
                    {...ShowScienceSt[lang].scienceText}
                  />
                  <SciImage
                    mt="2.5rem"
                    display={{ base: 'block', md: 'none' }}
                    src={scienceImg.image.url}
                  />
                  {/* <LazyLoadImageComponent
                      mt="2.5rem"
                      display={{ base: 'block', md: 'none' }}
                      src={scienceImg.image.url}
                    /> */}

                  {/* <StructuredTextParser
                      display={{ base: 'none', md: 'block' }}
                      str={render(stScienceImgText.body)}
                      mt="0"
                      {...ShowScienceSt[lang].scienceImageText}
                    /> */}
                </Box>
                <SciImage
                  display={{ base: 'none', md: 'block' }}
                  src={scienceImg.image.url}
                />
                {/* <LazyLoadImageComponent
                    display={{ base: 'none', md: 'block' }}
                    src={scienceImg.image.url}
                  /> */}
                {/* <StructuredTextParser
                    display={{ base: 'block', md: 'none' }}
                    str={render(stScienceImgText.body)}
                    mt=".5rem"
                    color="#fff"
                    
                    {...ShowScienceSt[lang].scienceImageText}
                  /> */}
              </Flex>
            </Collapse>
            {/* {!isVisible && (
                <>
                  <Box
                    maxWidth="300px"
                    width="100%"
                    margin="63px 0 0"
                    rounded="full"
                    className="card example-2"
                    position="relative"
                    overflow="hidden"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    boxShadow="0px 1.374px 15.632px 0px rgba(61, 30, 134, 0.69)"
                    _before={{
                      content: "''",
                      display: 'block',
                      background: 'rgba(255, 255, 255, 0.7)',
                      height: '55%',
                      width: '60%',
                      position: 'absolute',
                      animation:
                        'rotate 1.4s linear(0 0%, 0.1 20.67%, 0.48 51.42%, 0.89 80.16%, 1 100%) infinite',
                      zIndex: '0',
                      top: '10%',
                      left: '50%',
                      transformOrigin: 'left center',
                      transform: 'translate(-50%, -50%)',
                      // filter: 'blur(5px)',
                      // borderRadius: '100%',
                      // animation:
                      // 'rotate 3s linear(-0.01 8.02%, 1.18 91.31%) infinite',
                    }}
                  >
                    <Box
                      // padding="25px"
                      margin="1.5px"
                      background="#222"
                      color="#fff"
                      className="inner"
                      position="relative"
                      zIndex="1"
                      width="100%"
                      rounded="full"
                    >
                      <Button
                        bg="#0E0E0E"
                        border="none"
                        w="100%"
                        minH="56px"
                        color="#D9D9D9"
                        _hover={{ bg: 'rgba(255, 255, 255, 0.10)' }}
                        _focus={{ bg: 'rgba(255, 255, 255, 0.10)' }}
                        _active={{ bg: 'rgba(255, 255, 255, 0.10)' }}
                        onClick={() => setIsVisible(true)}
                        onMouseEnter={() => setIsHovered(true)}
                        rounded="full"
                        {...ShowScienceSt[lang].buttonText}
                      >
                        {sectionContent[9].buttonText}
                      </Button>
                    </Box>
                  </Box>
                </>
              )} */}
          </Box>
        </Box>
        {/* <LazyLoadImageComponent
            objectFit="cover"
            display={{ base: 'block', md: 'none' }}
            height={{ base: '316px' }}
            mt={{ base: '5rem', md: '126px' }}
            src={step2Img.image.url}
          /> */}
        {!isVisible && (
          <Box
            position="relative"
            height={{ base: '316px' }}
            zIndex={1}
            background="linear-gradient(0deg, #010102, #010102), linear-gradient(180deg, #000000 -4.27%, rgba(0, 0, 0, 0) 32.96%)"
            mt={{ base: '5rem', md: '126px' }}
          >
            {/* Image */}
            <LazyLoadImageComponent
              objectFit="cover"
              display={{ base: 'block', md: 'none' }}
              height="100%"
              objectPosition="top"
              width="100%"
              src={step2Img.image.url}
              zIndex={0} // Ensure image is underneath
            />
          </Box>
        )}
      </Flex>
    </Box>
  );
};

const ShowScience = ({ sectionContent, region, lang }) => {
  return (
    <Box
      bg="#010102"
      pos="relative"
      _after={{
        content: "''",
        pos: 'absolute',
        height: '0.6px',
        left: '0',
        right: '0',
        width: '100%',
        bottom: '0',
        zIndex: '1',
        background:
          'radial-gradient(80.14% 21.43% at 50% 50%, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0.00) 100%), #010102',
        backdropFilter: 'blur(calc(var(--sds-size-blur-100) / 2))',
        borderTop: '1px solid rgba(255, 255, 255, 0.20)',
      }}
    >
      <MainUi region={region} lang={lang} sectionContent={sectionContent} />

      <style>
        {`
          @keyframes rotate {
  0% {
    transform: rotate(0);
    height:55%;
  }
25%{
    transform: rotate(90deg);
height:150%;
}
50%{
    transform: rotate(180deg);
height:55%;
}
75%{
    transform: rotate(270deg);
height:150%;
}
  100% {
    transform: rotate(360deg);
    height:55%;
  }
}
          `}
      </style>
    </Box>
  );
};

export default ShowScience;
